export const IMAGE_ROLES = Object.freeze({
  FULL_SKIN_SCAN: 'full_skin_scan',
  FOCUSED_SKIN_AREA: 'focused_skin_area',
  SHADE_SKIN_REFERENCE: 'shade_skin_reference',
  INSPIRATION_REFERENCE: 'inspiration_reference',
  PRODUCT_REFERENCE: 'product_reference',
  GENERIC_CHAT_PHOTO: 'generic_chat_photo',
});

export const FOCUSED_SKIN_AREAS = Object.freeze([
  'cheek',
  'forehead',
  'chin',
  'jawline',
]);

const ROLE_VALUES = new Set(Object.values(IMAGE_ROLES));
const AREA_VALUES = new Set(FOCUSED_SKIN_AREAS);

export function createImageJourney(imageRole, { analysisScope } = {}) {
  if (!ROLE_VALUES.has(imageRole)) {
    throw new Error(`Unknown image role: ${imageRole}`);
  }

  if (imageRole === IMAGE_ROLES.FOCUSED_SKIN_AREA) {
    if (!AREA_VALUES.has(analysisScope)) {
      throw new Error('A focused skin photo needs a supported analysis area.');
    }
    return { imageRole, analysisScope };
  }

  if (analysisScope) {
    throw new Error('Analysis scope is only valid for a focused skin photo.');
  }

  return { imageRole };
}

// Legacy uploads have no role and keep their current behaviour. Every new
// onboarding route must name its role; only the full scan can update the
// canonical skin profile or create a full-face journal baseline.
export function canPersistFullSkinResult(imageRole) {
  return !imageRole || imageRole === IMAGE_ROLES.FULL_SKIN_SCAN;
}
